import { useMutation } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { queryClient } from "lib/react-query";
import { useCentralStore } from "stores";
import { useMessagesStore } from "../store";

export const sendMessage = ({ churchId, messageData }) => {
  return axios.post(`/churches/${churchId}/send-messages`, messageData);
};

// Backend may report a logical failure as { status: false, message, errors }
// with an HTTP 200, so success responses need the same check as errors.
export const getServerMessage = response =>
  response?.message ||
  (typeof response?.errors === "string" ? response.errors : null) ||
  (typeof response === "string" ? response : null) ||
  "Something went wrong. Please try again later.";

export const useSendMessage = ({ config } = {}) => {
  const setNotification = useCentralStore.getState().setNotification;
  const setMessage = useMessagesStore.getState().setMessage;
  const setServerErrors = useMessagesStore.getState().setServerErrors;

  return useMutation({
    onMutate: () => {
      setServerErrors(null);
    },
    onSuccess: (data, { notificationMessage }) => {
      if (data?.status === false) {
        setServerErrors(data?.errors);
        setNotification({ type: "error", message: getServerMessage(data) });
        return;
      }
      queryClient.invalidateQueries("messages");
      queryClient.invalidateQueries("send-messages");
      queryClient.invalidateQueries(["church"]); // refresh sms_used
      setNotification({
        type: "success",
        message: notificationMessage ?? "Message sent successfully!"
      });
      setMessage("");
    },
    onError: error => {
      setServerErrors(error?.errors);
      setNotification({ type: "error", message: getServerMessage(error) });
    },
    ...config,
    mutationFn: sendMessage
  });
};
